import React from 'react';

const ToggleGroup = ({ label, options, activeValue, onChange }) => {
  return (
    <div className="flex flex-col gap-1.5">
      <label className="text-sm font-medium text-slate-300">{label}</label>
      <div className="flex bg-slate-950 border border-slate-700 p-1 rounded-lg">
        {options.map((option) => (
          <button
            key={option.value}
            onClick={() => onChange(option.value)}
            className={`flex-1 py-1.5 text-xs font-semibold rounded-md transition-all ${
              activeValue === option.value
                ? 'bg-yellow-500 text-slate-950 shadow-sm'
                : 'text-slate-400 hover:text-slate-200'
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ToggleGroup;